import type { DetailedHTMLProps, HTMLAttributes } from "react";

export const MarkdownTh = (
  props: DetailedHTMLProps<
    HTMLAttributes<HTMLTableCellElement>,
    HTMLTableCellElement
  >,
) => {
  return <th className="text-left">{props.children}</th>;
};
